export default [
  { id: 1, name: 'Республика Адыгея' },
  { id: 2, name: 'Алтайский край' },
  { id: 3, name: 'Амурская область' },
  { id: 4, name: 'Архангельская область' },
  { id: 5, name: 'Астраханская область' },
  { id: 6, name: 'Республика Башкортостан' },
  { id: 7, name: 'Белгородская область' },
  { id: 8, name: 'Брянская область' },
  { id: 9, name: 'Республика Бурятия' },
  { id: 10, name: 'Владимирская область' },
  { id: 11, name: 'Волгоградская область' },
  { id: 12, name: 'Вологодская область' },
  { id: 13, name: 'Воронежская область' },
  { id: 14, name: 'Республика Дагестан' },
  { id: 15, name: 'Еврейская Автономная Область' },
  { id: 16, name: 'Забайкальский край' },
  { id: 17, name: 'Ивановская область' },
  { id: 18, name: 'Республика Ингушетия' },
  { id: 19, name: 'Иркутская область' },
  { id: 20, name: 'Кабардино-Балкарская республика' },
  { id: 21, name: 'Калининградская область' },
  { id: 22, name: 'Республика Калмыкия' },
  { id: 23, name: 'Калужская область' },
  { id: 24, name: 'Камчатский край' },
  { id: 25, name: 'Карачаево-Черкесская республика' },
  { id: 26, name: 'Республика Карелия' },
  { id: 27, name: 'Кемеровская область' },
  { id: 28, name: 'Кировская область' },
  { id: 29, name: 'Республика Коми' },
  { id: 30, name: 'Костромская область' },
  { id: 31, name: 'Краснодарский край' },
  { id: 32, name: 'Красноярский край' },
  { id: 33, name: 'Курганская область' },
  { id: 34, name: 'Курская область' },
  { id: 35, name: 'Ленинградская область' },
  { id: 36, name: 'Липецкая область' },
  { id: 37, name: 'Магаданская область' },
  { id: 38, name: 'Республика Марий Эл' },
  { id: 39, name: 'Республика Мордовия' },
  { id: 40, name: 'Москва' },
  { id: 41, name: 'Московская область' },
  { id: 42, name: 'Мурманская область' },
  { id: 43, name: 'Ненецкий Автономный Округ' },
  { id: 44, name: 'Нижегородская область' },
  { id: 45, name: 'Новгородская область' },
  { id: 46, name: 'Новосибирская область' },
  { id: 47, name: 'Омская область' },
  { id: 48, name: 'Оренбургская область' },
  { id: 49, name: 'Орловская область' },
  { id: 50, name: 'Пензенская область' },
  { id: 51, name: 'Пермский край' },
  { id: 52, name: 'Приморский край' },
  { id: 53, name: 'Псковская область' },
  { id: 54, name: 'Ростовская область' },
  { id: 55, name: 'Рязанская область' },
  { id: 56, name: 'Самарская область' },
  { id: 57, name: 'Санкт-Петербург' },
  { id: 58, name: 'Саратовская область' },
  { id: 59, name: 'Республика Саха (Якутия)' },
  { id: 60, name: 'Сахалинская область' },
  { id: 61, name: 'Свердловская область' },
  { id: 62, name: 'Республика Северная Осетия - Алания' },
  { id: 63, name: 'Смоленская область' },
  { id: 64, name: 'Ставропольский край' },
  { id: 65, name: 'Тамбовская область' },
  { id: 66, name: 'Республика Татарстан' },
  { id: 67, name: 'Тверская область' },
  { id: 68, name: 'Томская область' },
  { id: 69, name: 'Тульская область' },
  { id: 70, name: 'Республика Тыва' },
  { id: 71, name: 'Тюменская область' },
  { id: 72, name: 'Удмуртская республика' },
  { id: 73, name: 'Ульяновская область' },
  { id: 74, name: 'Хабаровский край' },
  { id: 75, name: 'Республика Хакасия' },
  { id: 76, name: 'Ханты-Мансийский Автономный Округ' },
  { id: 77, name: 'Челябинская область' },
  { id: 78, name: 'Чеченская республика' },
  { id: 79, name: 'Чувашская республика - Чувашия' },
  { id: 80, name: 'Чукотский Автономный Округ' },
  { id: 81, name: 'Ямало-Ненецкий Автономный Округ' },
  { id: 82, name: 'Ярославская область' },
];
